import { Notification } from '@smartgift/frontend-toolkit';
import React from 'react';
import { toast, Toaster } from 'react-hot-toast';
import styled from 'styled-components';

import { DURATION, Z_INDEX } from '@hero/constants';

import * as S from './style';

export function ToastProvider() {
  return (
    <S.ToastProvider>
      <Toaster
        position="top-right"
        containerStyle={{
          zIndex: Z_INDEX.toast
        }}
        toastOptions={{
          duration: DURATION.toast
        }}
      >
        {t => {
          const { title, message, status } = t.message || {};

          return (
            <StyledToastProvider>
              <Notification
                status={status}
                type="toast"
                isClosable
                title={title}
                message={message}
                onClose={() => toast.dismiss(t.id)}
              />
              {t.duration !== Infinity && (
                <ToastProviderProgress duration={DURATION.toast} status={status} />
              )}
            </StyledToastProvider>
          );
        }}
      </Toaster>
    </S.ToastProvider>
  );
}

const STATUS_COLOR = {
  success: 'var(--color-accent-primary-strong)',
  warning: 'var(--color-warning-strong)',
  error: 'var(--color-error-default)',
  info: 'var(--color-info-strong)'
};

const ToastProviderProgress = ({ duration, status }) => {
  return (
    <StyledToastProviderProgress>
      <StyledToastProviderProgressBar duration={duration} status={status} />
    </StyledToastProviderProgress>
  );
};

const StyledToastProvider = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const StyledToastProviderProgressBar = styled.div`
  animation: progress ${({ duration }) => duration}ms linear;
  background-color: ${({ status }) => STATUS_COLOR[status]};
  height: 100%;
  transition: width 0.1s linear;

  @keyframes progress {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }
`;

const StyledToastProviderProgress = styled.div`
  background-color: transparent;
  border-radius: 4px;
  bottom: 0;
  height: 4px;
  left: 0;
  max-width: 100%;
  overflow: hidden;
  position: absolute;
  right: 0;
  width: 100%;
`;
